// extracted by mini-css-extract-plugin
module.exports = {"baseBall":"index_baseBall__pXiRE","foggy":"index_foggy__7SzMz"};